'use strict';

import angular from 'angular';

class PositionTypeFormCtrl {
  model = {
    name: '',
    isActive: true
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, PositionTypeSvc,
    GrpTypeSvc, GroupSvc, GroupAuthSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.PositionTypeSvc = PositionTypeSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'positionType', 'C');

      this.submit = this.createPositionType;
      that.headerText = 'New Position Type';
      that.submitText = 'Create Position Type';
      GroupSvc.get({groupId}).$promise.then(function(group) {
        return GrpTypeSvc.getDesc({groupId}).$promise
          .then(function(gt) {
            var parentGrp = {name: group.name};
            that.model.groupType = parentGrp;
            that.groupTypes = [parentGrp].concat(gt);
          });
      });

      this.cancelSref = 'group.view.settings.positionType.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'positionType', 'U');

      this.submit = this.updatePositionType;
      var ptId = $stateParams.ptId;
      that.ptId = ptId;
      that.headerText = 'Edit Position Type';
      that.submitText = 'Update Position Type';
      this.PositionTypeSvc.get({groupId, id: ptId}).$promise
        .then(function(pt) {
          that.model = angular.copy(pt);
          that.displayGT = pt.groupType || pt.definedByGroup;
        });
      this.cancelSref = 'group.view.settings.positionType.list';
    }
  }

  createPositionType() {
    var that = this;
    that.LoaderSvc.start();
    var model = that.model;
    model.definedByGroupId = Number(that.groupId);
    // remove groupType if set to the definedBy Group (denoted by no id set)
    if(!model.groupType.id) { delete model.groupType; }
    if(model.groupType) {
      model.groupTypeId = model.groupType.id;
    }
    that.PositionTypeSvc.create({groupId: that.groupId}, this.model).$promise
      .then(function(pt) {
        that.LoaderSvc.stopSuccess('Position Type Created');
        that.$state.go('group.view.settings.positionType.list', {ptId: pt.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updatePositionType() {
    var that = this;
    that.LoaderSvc.start();

    this.PositionTypeSvc
      .update({groupId: that.groupId, id: that.ptId}, this.model).$promise
      .then(function() {
        that.$state
          .go('group.view.settings.positionType.list', {ptId: that.ptId});
        that.LoaderSvc.stopSuccess('Position Type Updated');
      })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

PositionTypeFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'PositionTypeSvc',
  'GrpTypeSvc',
  'GroupSvc',
  'GroupAuthSvc'
];

export default PositionTypeFormCtrl;
